import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { CopyIcon } from "../../../assets/icons";
import { getAssociatedStandards } from "../../../api/standardLinking.service";

const BulkRemoveAssociatedQuestionPopup: React.FC<any> = ({
  standardId,
  setShowModal,
  setQuestionIdsToRemove,
}: {
  standardId;
  setShowModal: (show: boolean) => void;
  setQuestionIdsToRemove: (questionIds: string) => void;
}) => {
  const [questionIds, setQuestionIds] = useState<string>();
  const [linkedStandardCount, setLinkedStandardCount] = useState<number>(0);

  function handleShowLinkedStandardsConfimation() {
    getAssociatedStandards(standardId).then((response) => {
      if (response && response.data.length > 0) {
        setLinkedStandardCount(response.data.length);
      }
    });
  }

  function copyQuestionIds() {
    if (questionIds) {
      setQuestionIds("");
    } else {
      let LS: any = localStorage.getItem("clipboard");
      if (LS) {
        LS = JSON.parse(LS);
        setQuestionIds(LS?.items.join(","));
      }
    }
  }

  function handleBulkRemove() {
    if (questionIds && questionIds.length > 0) {
      setQuestionIdsToRemove(questionIds);
      setShowModal(false);
    }
  }

  useEffect(() => {
    handleShowLinkedStandardsConfimation();
  }, [standardId]);
  return (
    <div>
      <Transition.Root show={true} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0"
          onClose={() => setShowModal(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 w-1/4">
                <form>
                  <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4"></div>
                  <div className="sm:flex sm:items-start">
                    <div className="w-full mt-3 text-center sm:mt-0 sm:text-left">
                      <label className="flex text-sm text-gray-700">
                        Question Ids
                        <CopyIcon
                          onClick={() => copyQuestionIds()}
                          title="Paste from clipboard"
                        />
                      </label>
                      <textarea
                        className="w-full shadow-sm border-gray-300 resize border rounded-md dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white"
                        value={questionIds}
                        rows={4}
                        style={{ display: "block" }}
                        onChange={(e) => {
                          setQuestionIds(e.target.value);
                        }}
                      ></textarea>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4 flex justify-end">
                    <button
                      onClick={handleBulkRemove}
                      type="button"
                      className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-500 text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm ${
                        questionIds && questionIds.length > 0
                          ? ""
                          : "text-white opacity-25 hover:bg-red-500 hover:opacity-25"
                      }`}
                    >
                      Remove
                    </button>
                    <button
                      onClick={() => setShowModal(false)}
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm"
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                    <span>
                      Question(s) will also be removed from{" "}
                      {linkedStandardCount} linked standard(s).
                    </span>
                  </div>
                </form>
              </div>
            </TransitionChild>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default BulkRemoveAssociatedQuestionPopup;
